module.exports = __webpack_public_path__ + "img/Dominos.596a630b.svg";